<template>
  <transition name="fade">
    <div
        v-if="show"
        class="dialog modal"
        @click="hideDialog"
    >
      <div @click.stop class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header">
            <h1 class="modal-title fs-5">{{ title }}</h1>
            <button type="button" class="button-close" @click="hideDialog">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M24 1.414L22.586 0L12 10.586L1.414 0L0 1.414L10.586 12L0 22.586L1.414 24L12 13.414L22.586 24L24 22.586L13.414 12L24 1.414Z"
                    fill="#005291"/>
              </svg>
            </button>
          </div>
          <div class="modal-body">
            <slot></slot>
          </div>
          <div class="modal-footer">
            <slot name="footer"></slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "ModalView",
  props: {
    show: {
      type: Boolean,
      default: false
    },
    selectedObj: {
      default: -1
    },
    title: String
  },
  methods: {
    hideDialog() {
      this.$emit('update:show', false);
      this.$emit('update:selectedObj', -1);
    }
  }
}
</script>

<style scoped>
.dialog {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(77, 84, 96, 0.7);
  display: block;
  z-index: 999;
}

.modal-header {
  justify-content: space-between;
}

.modal-header .modal-title {
  font-family: OpenSansBold, sans-serif;
  font-size: 24px !important;
  color: #005291;
}

.button-close {
  background: transparent;
  border: 0;
  outline: none;
  cursor: pointer;
}

.fade-enter-active {
  animation: fade-in .3s;
}

.fade-leave-active {
  animation: fade-in .3s reverse;
}

@keyframes fade-in {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

/* < 475 */
@media screen and (max-width: 474px) {
  .modal-header .modal-title {
    font-size: 18px !important;
  }
}

</style>